export default __webpack_public_path__ + "static/bg-submenu-1da458cb8c85620a8796a3d2af721785.jpg";